export const types = {
  'CHANGE_PASSWORD': 'CHANGE_PASSWORD',
  'SET_AUTH': 'setAuth',
  'USER_LOGIN': 'login',
  'USER_LOGOUT': 'logout',
  'RESET_STORE': 'RESET_STORE'
};
